<template>
  <div class="panel">
    <div class="panel__header" v-if="hasHeaderSlot || hasHeaderRightInfoSlot">
      <div class="panel__header_slot">
        <slot name="header"></slot>
      </div>
      <div class="panel__header__right-info" v-if="hasHeaderRightInfoSlot">
        <slot name="header_right_info"></slot>
      </div>
    </div>
    <div :class="bodyClasses" v-if="hasBodySlot">
      <slot></slot>
    </div>
    <div class="panel__footer" v-if="hasFooterSlot">
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "M4Panel",
  props: {
    noBodyGutters: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    bodyClasses() {
      let classes = ["panel__body"];
      if (this.noBodyGutters) {
        classes.push("panel__body--no-gutters");
      }
      if (!this.hasHeaderSlot && !this.hasFooterSlot) {
        classes.push("panel__body--no-header-footer");
      }
      return classes;
    },
    hasHeaderSlot() {
      return typeof this.$slots.header === "function";
    },
    hasHeaderRightInfoSlot() {
      return typeof this.$slots.header_right_info === "function";
    },
    hasBodySlot() {
      return typeof this.$slots.default === "function";
    },
    hasFooterSlot() {
      return typeof this.$slots.footer === "function";
    }
  }
};
</script>
